import React from 'react'
import '../dashboard/style.css'
import {Container, Row} from 'react-bootstrap'
import {Link} from 'react-router-dom'

export default function kategori() {
    return (
        <Container className="toko_reseller_kategori">
        <div className="dashboard-kategori">
            <h3>Kategori <Link to="categoryber">Lihat Selengkapnya</Link></h3>
            <Row>
            {
                Kategori.map((data, i) => {
                    return (
                        <div key={i} className="kategori-cards">
                            <Link to={data.link}>
                                <img src={data.src} alt="kategori" />
                                <div className="kategori-teks">
                                   <p>{data.text}</p> 
                                </div>
                            </Link>
                        </div>
                    )
                })
            }
            </Row>
        </div>
       </Container>
    )
}

const Kategori = [
    {src:"asset/dashboard/kategori/kategori1.png", text:"Al-Qur’an", link:"categoryber"},
    {src:"asset/dashboard/kategori/kategori1.png", text:"Buku Cetak K13", link:"categoryber"},
    {src:"asset/dashboard/kategori/kategori1.png", text:"Kurma", link:"categoryber"},
    {src:"asset/dashboard/kategori/kategori1.png", text:"Buku Islami", link:"categoryber"}
]
